import {sample} from 'effector';

import {fetchFactory} from 'api';

import {editFactoryBatchFx} from '../factoryOperations';

import {factory$, FactoryDetailsGate, loadFactoryFx} from './index';

loadFactoryFx.use((params) => fetchFactory(params.id));

factory$.on(loadFactoryFx.doneData, (_, data) => data).reset(FactoryDetailsGate.close);

sample({
    clock: FactoryDetailsGate.open,
    source: FactoryDetailsGate.state,
    target: loadFactoryFx,
});

sample({
    clock: editFactoryBatchFx.done,
    source: FactoryDetailsGate.state,
    target: loadFactoryFx,
});
